module.exports = __webpack_public_path__ + "img/color-lerp-example.6dfaed18.gif";